module.exports = __webpack_public_path__ + "img/add_btn_icon480.d7274d4b.svg";